import { Component, OnInit, HostListener, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ConnectRestService } from 'src/app/services/connect-rest.service';
import { AppUtilityService } from 'src/app/common/app-utility.service';
import { environment, countryCodes } from 'src/environments/environment.prod'
import { EnglishTranslation, MalayTranslation } from '../app.constants';
import { UUID } from 'angular2-uuid';
import { DataStoreService } from '../data-store.service';

declare var $: any;
@Component({
  selector: 'app-tell-us',
  templateUrl: './tell-us.component.html',
  styleUrls: ['./tell-us.component.scss']
})
export class TellUsComponent implements OnInit, AfterViewInit {

  applicantInfo: FormGroup;
  // private phonePattern = /^((60(\s|-)?))(((?!0)(?![2-9])(?!80)(?!81)\d{1,2})[1]?)(\s|-)?\d{2,4}(\s|-)?\d{4}$/;
  // private phonePattern = /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/;
  // private emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  mobileMaxInput : Number = 48;
  mobileMinInput : Number = 1;
  mobileNumberPattern : any = this.AppUtility.mobileNumberPattern('60');
  CountryCodes = countryCodes;
  contactInfo: string;
  isContactInfo: any = sessionStorage.getItem("contactInfo");
  retrieveData: string;
  ConnectedParties: any;
  CompanyDetails: any;
  partyCounts: boolean = false;
  disableBack: boolean = false;
  textContent: any;
  langTranslation: any;
  onload: boolean = true;
  showModal: boolean = false;
  captcha: any = 'assets/images/capcha-mock.png';
  captchaID: string = '';
  captchaNote: string = '';
  captchaError: boolean = false;
  modalMessage: string;
  ModalSMS: boolean = true;
  captchaSuccess: boolean;

  constructor(public router: Router,
    private formBuilder: FormBuilder,
    private connect: ConnectRestService,
    private AppUtility: AppUtilityService,
    private dataStoreService: DataStoreService
  ) {
    //used to prevent back button --- added by Sonny
    sessionStorage.currentPage = window.location.href;
   }

  @HostListener('document:keypress', ['$event'])
  onKeyPress(elemValue) {
    if (elemValue.target.id === 'applicant_mobile_number') {
      return this.AppUtility.mobileNumberValidation(elemValue.key)
    } else if (elemValue.target.type === 'text' || elemValue.target.type === 'email') {
      return this.AppUtility.characterValidation(elemValue.key)
    }
  }


  ngOnInit() {
    //This is to handle back button from OTP page
    //Added by Sonny - 09 Jun 2020 
    this.langTranslation = sessionStorage.getItem("language");
    this.textContent = this.langTranslation == 'en-us' || this.langTranslation == undefined ? EnglishTranslation.TellUsScreen : MalayTranslation.TellUsScreen;
    this.captchaNote = this.textContent.note1;
    this.captchaSuccess = sessionStorage.getItem("captchaSuccess") == 'true';
    this.contactInfo = sessionStorage.getItem("contactInfo");
    this.retrieveData = sessionStorage.getItem("RetrieveData");
    var defaultValue = { "ApplicantName": null, "EmailAddress": null, "mobileNumber": null, "countryCode": '60' }
    if (sessionStorage.TellUsWhoYouAre) {
      let tempValue = JSON.parse(sessionStorage.TellUsWhoYouAre)
      defaultValue = JSON.parse(sessionStorage.TellUsWhoYouAre)
      defaultValue.mobileNumber = tempValue.mobileNumber.split('-')[1]
      defaultValue.countryCode = tempValue.mobileNumber.split('-')[0]
    } else {
      // change condition later
      // this.connect.clearSessionStorage();
    }
    if(sessionStorage.getItem("disableBack") == "true"){
      this.disableBack = true;
    }else {
      this.disableBack = false;
    }
    this.applicantInfo = this.formBuilder.group({
      // temporary data of company details - by Howard
      Name: [''],
      BusinessRegNo: [''],
      BusinessType: [''],
      NRIC: [''],
      // applicantName: [defaultValue.ApplicantName, Validators.required],
      mobileNumber: [defaultValue.mobileNumber, [Validators.required, Validators.pattern(this.mobileNumberPattern)]],
      email: [defaultValue.EmailAddress, [Validators.required, Validators.pattern(environment.emailPatternHTML5)]],
      applicantCountryCode: [defaultValue.countryCode, [Validators.required]],
      captcha: [{value: '',disabled: this.captchaSuccess}],
    });
    
    if(this.contactInfo == 'true') {
      this.getCaptcha(false);
    }

    $(document).ready(() => {
      $("form").bind("keypress", (e) => {
        if (e.keyCode == 13) {
          return false;
        }
      })

      $("#obaoform").validate({
       
        rules: {
          applicant_name: {
            required: true,
          },
          applicant_mobile_number: {
            required: true,
            number: true
          },
          email_address: {
            required: true
          },
          captcha: {
            required: true
          }
        },
        messages: {

          applicant_name: {
            required: "Please enter applicant name"
          },
          applicant_mobile_number: {
            required: this.textContent.numberError.required,
            minlength:  () => { return this.textContent.numberError.minlength1 + this.mobileMinInput + this.textContent.numberError.minlength2 },
            pattern: this.textContent.numberError.pattern
          },
          email_address: {
            required: this.textContent.emailError.required ,
            email: this.textContent.emailError.pattern,
            pattern: this.textContent.emailError.pattern
          },
          captcha: {
            required: ''
          }


        }, errorPlacement: function (error, element) {

          if (element.attr("name") == "applicant_name") {
            error.appendTo($("#applicant_name_error_container"));
          }
          if (element.attr("name") == "applicant_mobile_number") {
            error.appendTo($("#applicant_mobile_error_container"));
          }
          if (element.attr("name") == "email_address") {
            error.appendTo($("#email_address_error_container"));
          }
          if (element.attr("name") == "captcha") {
            error.appendTo($("#captcha_error_container"));
          }

        },
        submitHandler: function (form) {
          // $("#btn-next").prop("disabled", true);
        }

      });


    });

    //this.onCountryCodeChange($('#countryCode').val())
    this.onCountryCodeChange(this.applicantInfo.value.applicantCountryCode);
    if (this.contactInfo == "false"){
      // console.log("contact info");
      this.requestCompanyData()
      this.applicantInfo.controls['NRIC'].setValidators(Validators.required);
    } else {
      this.applicantInfo.controls['captcha'].setValidators(Validators.required);
    }
  }

  async ngAfterViewInit() {
    if(await this.dataStoreService.getAAStatus()) {
      if(this.contactInfo == 'true') 
        this.dataStoreService.setAAData('tell-us');
    }
  }

  async getCaptcha(action) {
    var RequestID = "G0001";
    var uuid = sessionStorage.getItem('UUID') || UUID.UUID();
    var data = {get: true, uuid};
    if(action) {
      if (this.captchaSuccess) return;
      RequestID = "G0002"
      data['captchaId'] = this.captchaID;
      data['get'] = false;
    } 
    var temp = {
      "headers": { 'x-source-country' : 'MY',
      'x-source-id': 'MOBAO',
      'x-correlation-id' : uuid,
      'x-source-date-time' : new Date().toISOString() }
    }
    try{
      var responseData = await this.connect.connectRest(data, RequestID, temp);
      if(responseData.Status == "Success"){
        sessionStorage.setItem('UUID', uuid);
        $('.ErrorDisplayHTML').remove();
      }else{
        $('#btn-next').attr('disabled',true);
      }
      this.captcha = "data:image/png;base64," + responseData['data'].image;
      this.captchaID = responseData['data'].captchaId;
    } catch(ex){
      this.connect.displayErrorMessage(ex)
    }
  }
  
  checkNext() {
    return !this.applicantInfo.valid;
    // return this.contactInfo == 'true' ? !this.applicantInfo.valid : (!this.applicantInfo.valid || this.applicantInfo.get("CheckBox").value != true);
  }

  testValid(){
    this.applicantInfo.controls['Name'].setValue($('select[name=NRIC] option:selected').text())
    // console.log(this.applicantInfo.value)
  }
  
  async requestCompanyData(){
    const RequestID = 'R0016';   
    if(this.retrieveData == "true"){
      const resp :any = await this.connect.connectRest("", RequestID, '');
      this.ConnectedParties = resp.ConnectedParties;
      if (this.ConnectedParties.length == 1) {
        this.applicantInfo.patchValue({
          Name: this.ConnectedParties[0].Name,
          StrSelected: this.ConnectedParties[0].StrSelected
        })
        if(this.ConnectedParties[0].Email != undefined){
          this.applicantInfo.patchValue({
            email: this.ConnectedParties[0].Email,
          })
        }
        if(this.ConnectedParties[0].mobileNumber != undefined){
          var mobileNumberData = this.ConnectedParties[0].mobileNumber.split('-');
          this.applicantInfo.patchValue({
            applicantCountryCode:mobileNumberData[0],
            mobileNumber:mobileNumberData[1],
          })
        }        
        this.partyCounts = true;
        this.applicantInfo.controls['NRIC'].setValue(this.ConnectedParties[0].NRIC);
        this.applicantInfo.controls['NRIC'].disable();
        this.applicantInfo.controls['NRIC'].updateValueAndValidity();
      } else {
        var selectedNRIC = '';
        var selectedEmail;
        var selectedMobileNumber;
        var selectedName;
        for(var i = 0; i<resp.ConnectedParties.length; i++){
          if(resp.ConnectedParties[i].StrSelected=="true"){
            selectedName = resp.ConnectedParties[i].Name
            selectedNRIC = resp.ConnectedParties[i].NRIC
            selectedEmail = resp.ConnectedParties[i].Email
            selectedMobileNumber = resp.ConnectedParties[i].mobileNumber.split('-')
          }
        }
        this.applicantInfo.patchValue({
          Name: selectedName,
          NRIC:selectedNRIC,
          email: selectedEmail,
          applicantCountryCode:selectedMobileNumber[0],
          mobileNumber:selectedMobileNumber[1]
        })
        this.partyCounts = false;
      }
    } else {    
      var ctosData = JSON.parse(sessionStorage.ConnectedParties);
      var requestData = {ConnectedParties:[]};
      requestData.ConnectedParties = ctosData.CompanyDetails.ConnectedParties;
      const companyData :any  = await this.connect.connectRest(requestData, RequestID, '');
      this.ConnectedParties = companyData.ConnectedParties;
      this.CompanyDetails = JSON.parse(sessionStorage.getItem('company-details'));
      if (this.ConnectedParties.length == 1) {
          this.applicantInfo.patchValue({
            Name: this.ConnectedParties[0].Name,
            StrSelected: this.ConnectedParties[0].StrSelected
          })
          if(this.ConnectedParties[0].Email != undefined){
            this.applicantInfo.patchValue({
              email: this.ConnectedParties[0].Email,
            })
          }
          if(this.ConnectedParties[0].mobileNumber != undefined){
            var mobileNumberData = this.ConnectedParties[0].mobileNumber.split('-');
            this.applicantInfo.patchValue({
              applicantCountryCode:mobileNumberData[0],
              mobileNumber:mobileNumberData[1],
            })
          }
          this.partyCounts = true;
          this.applicantInfo.controls['NRIC'].setValue(this.ConnectedParties[0].NRIC);
          this.applicantInfo.controls['NRIC'].disable();
          this.applicantInfo.controls['NRIC'].updateValueAndValidity();
      } else {
          var selectedNRIC = '';
          var selectedEmail;
          var selectedMobileNumber;
          var selectedName;
          for(var i = 0; i<companyData.ConnectedParties.length; i++){
            if(companyData.ConnectedParties[i].StrSelected=="true"){
              selectedName = companyData.ConnectedParties[i].Name
              selectedNRIC = companyData.ConnectedParties[i].NRIC
              selectedEmail = companyData.ConnectedParties[i].Email
              selectedMobileNumber = companyData.ConnectedParties[i].mobileNumber.split('-')
            }
          }
          if (selectedMobileNumber && selectedEmail) {
            this.applicantInfo.patchValue({
              Name: selectedName,
              NRIC: selectedNRIC,
              email: selectedEmail,
              applicantCountryCode: selectedMobileNumber[0],
              mobileNumber: selectedMobileNumber[1]
            })
          } else {
            this.applicantInfo.patchValue({
              Name: selectedName,
              NRIC:selectedNRIC
            })
          }
          this.partyCounts = false;
        }
      }
      
    }

  public onSubmit() {
    var serviceBody= {};
    if(this.isContactInfo == "false") {
      serviceBody = {
        'Name': this.applicantInfo.value.Name,
        'Email': this.applicantInfo.value.email,
        'mobileNumber': this.applicantInfo.value.applicantCountryCode + '-' + this.applicantInfo.value.mobileNumber,
        'NRIC': this.applicantInfo.controls['NRIC'].value,
        'StrSelected': 'true',
        Language: this.langTranslation
      };
      //this.restConnect(serviceBody);
      this.updateMethod(serviceBody);
    }else {
      if ($("#obaoform").valid()) {
        serviceBody = {
         // 'ApplicantName':"Dummy",
          'EmailAddress': this.applicantInfo.value.email,
          'mobileNumber': this.applicantInfo.value.applicantCountryCode + '-' + this.applicantInfo.value.mobileNumber
        };
        this.restConnect(serviceBody);
        //this.updateMethod(this.applicantInfo.value);
      }
  
      // this.restConnect(serviceBody)
    } 
    
  }

  public async restConnect(data) {
    //Request to be send at OTP page as per requirement for PEGA
    //Added by Sonny - 09 Jun 2020

    /*
    const RequestID = 'R0000';
    const responseData = await this.connectRestService.connectRest(data, RequestID, '')
    if (responseData.Status === 'Success') {
      this.router.navigate(['/otp']);
    }
    */

    //Storing information at a browser storage    
    sessionStorage.TellUsWhoYouAre = JSON.stringify(data)
  
    if(this.isContactInfo == "false"){
      this.router.navigate(['/business-detail']);
    }else{
      try{
        var data = JSON.parse(sessionStorage.TellUsWhoYouAre);
        data.ProductCode = sessionStorage.currentProduct;
        data.Language = this.langTranslation;
        var check = sessionStorage.captchaSuccess
        if (!check)
        data.CaptchaDetails = {
          CaptchaID: this.captchaID,
          Value: $('#captcha').val()
        }
        const RequestID = "S0000"
        var responseData = await this.connect.connectRest(data, RequestID, '')
        if(responseData.Status == "Success"){
          $('.ErrorDisplayHTML').remove()
          $('#otp_number').val("")
          this.showModal = true;
          sessionStorage.setItem('captchaSuccess', 'true');
          this.captchaSuccess = true;
          this.captchaError = false;
          this.captchaNote = this.textContent.note1;
          this.applicantInfo.controls['captcha'].disable();
        }else{
          this.hadleErrorCaptchError(responseData['ServiceMessage']);
        }
      } catch(ex){
        this.connect.displayErrorMessage(ex)
      }
    }
   
  }

  hadleErrorCaptchError(e) {
    if(e.ErrorCode == 'EC092')  {
      this.captchaNote = e.ErrorDescription;
      this.captchaError = true;
    } else if (e.ErrorCode == 'EC093') {
      this.modalMessage = e.ErrorDescription;
      this.captchaError = false;
      this.ModalSMS = false;
      this.showModal = true;
    }
  }

  goTOLandingPage() {
    var params = JSON.parse(localStorage.getItem("SavedQueryParams"));
    delete params.productdescription;
    this.router.navigate(['/start'], {queryParams : params});
  }

  onCountryCodeChange(elemValue) {
    var respValue = this.AppUtility.mobileNumberMinMaxLength(elemValue)
    this.mobileMaxInput = respValue.max
    this.mobileMinInput = respValue.min

    // Added by CJ for Mobile Number Pattern 14Jul2020
    if(!this.onload) {
      this.applicantInfo.controls['mobileNumber'].setValue('');
    }
    this.mobileNumberPattern = this.AppUtility.mobileNumberPattern(elemValue);
    this.applicantInfo.get("mobileNumber").setValidators([Validators.required,Validators.pattern(this.mobileNumberPattern)]);
    this.onload = false;
  }

  resetMobileValidation(){
    if(this.applicantInfo.controls['mobileNumber'].dirty){
    $('#applicant_mobile_number').valid()
    }
  }

  
  public async updateMethod(data) {
    const RequestID = 'S0016';
    const companyData = await this.connect.connectRest(data, RequestID, '')
    if (companyData.Status === 'Success') {
      this.router.navigate(['/business-detail']);
    }  
  }

  onPreviousClick() {
    var params = JSON.parse(localStorage.getItem("SavedQueryParams"));
    delete params.productdescription;
    this.router.navigate(['/start'], {queryParams : params});
  }

  async getRefData(){
    var responseData = await this.connect.connectRest({Keys:[{Code:"ALL"}], Language: sessionStorage.language},"R0300","")
    if(responseData.Status == "Success"){
      var RefCODL=[]
      var RefBPDL=[]
      var RefSCDL=[]
      var RefCCDL=[]
      var RefPADL=[]
      var RefNTDL=[]
      var RefETDL=[]
      var RefET=[]
      var RefDWDL=[]
      var RefPPDL=[]
      var RefDWC = []
      var RefRACE = []

      RefCODL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID =="CODL"
      }))

      RefBPDL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID =="BPDL"
      }))

      RefSCDL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID =="SCDL"
      }))

      RefCCDL.push(responseData['RefDetails'].filter(function(obj){
        return (obj.ID =="CCDL" && obj.Code != "ZZ")
      }))

      RefPADL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID =="PADL"
      }))

      RefNTDL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID =="NTDL"
      }))

      RefETDL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID =="ETDL"
      }))

      RefET.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID == "PTDL"
      }))

      RefDWDL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID == "DWDL"
      }))

      RefPPDL.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID == "PPDL"
      }))

      RefDWC.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID == "DWC"
      }))

      RefRACE.push(responseData['RefDetails'].filter(function(obj){
        return obj.ID == "Race"
      }))

      sessionStorage.RefCODL = JSON.stringify(RefCODL[0])
      sessionStorage.RefBPDL = JSON.stringify(RefBPDL[0])
      sessionStorage.RefSCDL = JSON.stringify(RefSCDL[0])
      sessionStorage.RefCCDL = JSON.stringify(RefCCDL[0])
      sessionStorage.RefPADL = JSON.stringify(RefPADL[0])
      sessionStorage.RefNTDL = JSON.stringify(RefNTDL[0])
      sessionStorage.RefETDL = JSON.stringify(RefETDL[0])
      sessionStorage.RefET = JSON.stringify(RefET[0])
      sessionStorage.RefDWDL = JSON.stringify(RefDWDL[0])
      sessionStorage.RefPPDL = JSON.stringify(RefPPDL[0])
      sessionStorage.RefDWC = JSON.stringify(RefDWC[0])
      sessionStorage.RefRACE = JSON.stringify(RefRACE[0])
      return true
    }else{
      $('.obao-link').addClass('hidden')
      $('#btn-next').attr('disabled',true)
      $('#otp_number').attr('disabled',true)
      return false
    }
  }

  async modalAction(action) { 
    if(action == 'Yes') {
      sessionStorage.setItem("contactInfo", "false");
      this.getRefData();
      this.router.navigate(['/identify-your-company']);
    }
    this.showModal = false;    
  }
}
